import axios from 'api';
import { showMessage } from 'app/store/actions/fuse';
import { getCurrentApiUrl } from 'app/helpers';
import i18n from 'i18next';

require('dotenv').config();

export const RESET_DASHBOARD_SLIDES = '[CONSOLE] RESET_DASHBOARD_SLIDES';
export const GET_DASHBOARD_SLIDES = '[CONSOLE] GET SLIDES';
export const GET_DASHBOARD_SLIDE_UNIT = '[CONSOLE] GET SLIDES UNIT';

export function resetDashboardSlides() {
  return {
    type: RESET_DASHBOARD_SLIDES
  };
}

export function getDashboardSlides(status) {
  const request = axios.get(
    `${getCurrentApiUrl()}/dashboard/slides?status=${status}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DASHBOARD_SLIDES,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getDashboardSlidesUnit(id) {
  const request = axios.get(`${getCurrentApiUrl()}/dashboard/slides/${id}`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DASHBOARD_SLIDE_UNIT,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function orderChange(arrayOrder) {
  const request = axios.post(
    `${getCurrentApiUrl()}/dashboard/slides/order`,
    arrayOrder
  );
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.modify.modify_success') })
        );
        dispatch(getDashboardSlides());
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function deleteSlide(id, navigate) {
  const request = axios.delete(
    `${getCurrentApiUrl()}/dashboard/slides/${id}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.delation.deletion_success') })
        );
        dispatch(getDashboardSlides());
        navigate('/dashboard/slides');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function updateSlides(data, id) {
  const request = axios.put(
    `${getCurrentApiUrl()}/dashboard/slides/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.modify.modify_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function createSlides(data, navigate) {
  const request = axios.post(`${getCurrentApiUrl()}/dashboard/slides`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return dispatch =>
    request
      .then(response => {
        dispatch(showMessage({ message: i18n.t('action.creation.creation_success') }));
        navigate('/dashboard/slides');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function deleteImageSlide(id) {
  const request = axios.delete(
    `${getCurrentApiUrl()}/dashboard/slides/image/${id}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({
            message: i18n.t('action.delation.success_message_updated_f', {
              entity: i18n.t('image')
            })
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}
